/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */

import axios from "axios";
import { Power0, TweenMax } from "gsap";
import $ from "jquery";
import moment from 'moment';
import 'slick-carousel';
import Parsley from "parsleyjs";
import MicroModal from 'micromodal';
import "./index.scss";
import AOS from 'aos'

var imagesLoaded = require("imagesloaded");

// eslint-disable-next-line no-unused-vars
let AppComponent = (function () {
  let APP_H = window.innerHeight,
    APP_W = window.innerWidth,
    scrollTop = $(window).scrollTop(),
    // preloading,
    $body = $("body"),
    imagesSize = 0,
    imagesLoadedCount = 0,
    $percentOutput = $(".lp-progress-percent"),
    $progressBar = $(".lp-progress-bar span");

  let setupForm = function () {
    Parsley.addMessages("pl", {
      defaultMessage: "Wartość wygląda na nieprawidłową.",
      type: {
        email: "Wpisz poprawny adres e-mail.",
        url: "Wpisz poprawny adres URL.",
        number: "Wpisz poprawną liczbę.",
        integer: "Dozwolone są jedynie liczby całkowite.",
        digits: "Dozwolone są jedynie cyfry.",
        alphanum: "Dozwolone są jedynie znaki alfanumeryczne.",
      },
      notblank: "Pole nie może być puste.",
      required: "Pole jest wymagane.",
      pattern: "Pole zawiera nieprawidłową wartość. Wpisz numer telefonu w formacie 9-cyfrowym, np. 123123123.",
      min: "Wartość nie może być mniejsza od %s.",
      max: "Wartość nie może być większa od %s.",
      range: "Wartość powinna zaweriać się pomiędzy %s a %s.",
      // minlength:      "Minimalna ilość znaków wynosi %s.",
      minlength: "Wpisz telefon w formacie 123-456-789.",
      maxlength: "Maksymalna ilość znaków wynosi %s.",
      length: "Ilość znaków wynosi od %s do %s.",
      mincheck: "Wybierz minimalnie %s opcji.",
      maxcheck: "Wybierz maksymalnie %s opcji.",
      check: "Wybierz od %s do %s opcji.",
      equalto: "Wartości nie są identyczne.",
    });

    Parsley.setLocale("pl");
  };

  let submitForm = function ($form) {
      let $this = $form,
          data = $this.serialize(),
          id = $this.attr('id'),
          url = $this.attr('action')

      url = url.replace('submit_', '')

      $.ajax({
          url: url ? url : '/',
          type : 'POST',
          cache : false,
          data : data,
          beforeSend: function() {
              $this.find('.btn').html('Proszę czekać...')
              $this.find('.btn').attr('disabled', 'disabled')
              $this.parent().find('.section-formMessage').addClass('hidden')
              $this.parent().find('.section-formMessage .success').addClass('hidden')
              $this.parent().find('.section-formMessage .error').addClass('hidden')
          },
          success: function(_res) {
              let res = JSON.parse(_res)

              if (res.status) { // saved
                  $this.get(0).reset()

                  $this.fadeOut(function() {
                      $this.parent().find('.section-formMessage').removeClass('hidden')
                      $this.parent().find('.section-formMessage .success').removeClass('hidden')

                      $('html, body').animate({
                          scrollTop: $('.section-formMessage').offset().top - $('.header').height()
                      }, 300)
                  })
                  
                  // if (window.location.href.indexOf('?testujemy') > 0) {
                  //   console.log('res', res)
                  // } else {
                  //   window.location = '/dziekujemy/'
                  // }
              } else {
                  $this.parent().find('.section-formMessage').removeClass('hidden')
                  $this.parent().find('.section-formMessage .error').removeClass('hidden')
                  $this.find('.btn').attr('disabled', false)
                  $this.find('.btn').html('Wyślij')
              }
          }, 
          error: function(res) {
              // $this.find('.btn').html('Wyślij')
              // $this.find('.btn').attr('disabled', false)
              // $this.parent().find('.section-formMessage').removeClass('hidden')
              // $this.parent().find('.section-formMessage .error').removeClass('hidden')

              $this.get(0).reset()

              $this.fadeOut(function() {
                  $this.parent().find('.section-formMessage').removeClass('hidden')
                  $this.parent().find('.section-formMessage .success').removeClass('hidden')

                  $('html, body').animate({
                      scrollTop: $this.parent().find('.section-formMessage').offset().top - $('.header').height() - 100
                  }, 300)
              })
          },
      })
  };

  let showHideNav = function () {
    let $navTrigger = $(".header-navTrigger"),
      $nav = $(".header-nav"),
      isNavActive = $nav.hasClass("active");

    if (isNavActive && APP_W <= 768) {
      $navTrigger.removeClass("active");
      $nav.removeClass("active");
    } else {
      $navTrigger.addClass("active");
      $nav.addClass("active");
    }
  };

  let setupEvents = function () {
    $(window).on("resize", function (event) {
      APP_H = window.innerHeight;
      APP_W = window.innerWidth;
    });

    $(window).on("scroll", function (event) {
      scrollTop = $(window).scrollTop();
    });

    $("#answer").on("keyup", function () {
      let $this = $(this);
      $this.val($this.val().substring(0, 1000));
      let thisId = $this.attr("id");
      let $label = $(`label[for="${thisId}"]`);
      let template = $this.data("template");
      let limit = $this.val().length;
      let newLabel = template.replace("CURRENT", limit);
      $('.textarea-counter').html(newLabel);
    });

    $("form").on("submit", function (event) {
      event.preventDefault();
      let _id = "#" + $(this).attr("id");
      let formParsley = $(_id).parsley();

      formParsley.destroy();

      if (formParsley.validate()) {
        submitForm($(_id));
      }
    });

    $("[data-bypass]").on("click", function (event) {
      event.preventDefault();
      window.open($(this).attr("href"));
    });

    $(".header-navTrigger").on("click", function (event) {
      event.preventDefault();

      showHideNav();
    });

    $(".header-nav-link").on("click", function (event) {
      if (!$(this).data("bypass")) {
        event.preventDefault();
      }

      showHideNav();
    });

    $(".section-winnersSwitcher button").on("click", function (event) {
      event.preventDefault();
      //
      let $this = $(this);

      if (!$this.parent().hasClass("disabled")) {
        let divToShow = "#" + $this.data("show");
        //
        $(".section-winnersSwitcher li").removeClass("active");
        $this.parent().addClass("active");
        //
        $(".contestResults").removeClass("active");
        $(divToShow).addClass("active");

        if (APP_W < 768) {
          $("html, body").animate(
            {
              scrollTop: $(divToShow).offset().top - $(".header").height() - 46,
            },
            300
          );
        }
      }
    });

    $('.block-wyborowa').on('click', function() {
      $(this).toggleClass('active')
      
      if ($('.precontest').length > 0 || $('.thankyou').length > 0) {
        return
      }

      if ($(this).hasClass('active')) {
        setTimeout(() => {
          $("html, body").animate(
            {
              scrollTop: $("#zasady").offset().top - $(".header").height() - 46,
            },
            300
          );
        }, 600)
      }
    })
  };

  let enableSmoothScroll = function () {
    $('a[href*="#"]')
      .not('[href="#"]')
      .not('[href="#0"]')
      .not(".open-popup")
      .click(function (event) {
        if (
          window.location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") &&
          window.location.hostname == this.hostname
        ) {
          let target = $(this.hash);
          let hash = this.hash;
          target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");

          if (target.length) {
            event.preventDefault();

            let offsetTop = target.offset().top - $(".header").outerHeight() + 4;

            $("html, body").animate(
              {
                scrollTop: offsetTop,
              },
              500,
              function () {
                if (hash == "#top") {
                  $("#formularz").find("input").first().focus();
                }
              }
            );
          }
        }
      });
  };

  var onLoadDone = function () {
    $body.find(".preloading").each(function (index, el) {
      $(this).remove();
    });

    TweenMax.to($(".lp-preload"), 0.1, {
      opacity: 0,
      ease: Power0.easeOut,
      onComplete: function () {
        setTimeout(function () {
          // animateStage();
          $body.removeClass("loading");

          MicroModal.init({
            onShow: (modal) => {
              $('body').addClass('prevent-scroll')

              $(`#${modal.id}`).find('.section-slider--modal-gallery').slick({
                lazyLoad: 'ondemand',
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
              });
            },
            onClose: (modal) => {
              $('body').removeClass('prevent-scroll')
              $(`#${modal.id}`).find('.section-slider--modal-gallery').slick('unslick')
            },
          });
          AOS.init()

         initSliders()
        }, 200);
      },
    });
  };

  var onProgress = function (instance, image) {
    let result = image.isLoaded ? "loaded" : "broken";
    //
    imagesLoadedCount = imagesLoadedCount + 1;

    let percent = (100 * (imagesLoadedCount / imagesSize)).toFixed(0);

    $percentOutput.html(percent + "%");
    $progressBar.css("width", percent + "%");
  };

  let preload = function (images) {
    var _this = this,
      imgLoad;

    if (images) {
      $.each(images, function (index, val) {
        $("body")
          .find(".footer")
          .append('<img class="preloading" src=" ' + val + ' ">');
      });
    }

    imgLoad = imagesLoaded("body", { background: true });
    imagesSize = imgLoad.images.length;

    imgLoad.on("done", onLoadDone);
    imgLoad.on("fail", onLoadDone);
    imgLoad.on("progress", onProgress);
  };

  let setCountDown = () => {
    var eventdate = moment("2022-11-16");
    var eventdateEndOfDay = moment("2022-11-16 23:59");
    var todaysdate = moment().subtract(1, 'day');
    let diff = eventdate.diff(todaysdate, 'days');

    if (diff === 1) {
      $('.days-left-txt').html('pozostał')
      $('.days-dayname-txt').html('dzień')
    }

    // console.log( 'checking', 'diff', diff, moment().isBefore(eventdateEndOfDay) )
    
    let text = diff.toString().split('')

    $('.days-count').html( '<span>' + text.join('</span><span>') + '</span>' );

    if (diff > 0) {
      $('.section-heroText-start').removeClass('hidden')
    } else if (!moment().isBefore(eventdateEndOfDay)) {
      $('.section-heroText-startNow').removeClass('hidden')
    } 
  }

  let initSliders = () => {
    $('.section-slider--facts').slick({
      // centerMode: true,
      lazyLoad: 'ondemand',
      dots: true,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      // centerPadding: '120px',
      // responsive: [
      //   {
      //     breakpoint: 768,
      //     settings: {
      //       slidesToShow: 2,
      //       slidesToScroll: 2
      //     }
      //   }
      // ]
    });

    $('.section-slider--videos').slick({
      // centerMode: true,
      dots: false,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      // responsive: [
      //   {
      //     breakpoint: 768,
      //     settings: {
      //       slidesToShow: 2,
      //       slidesToScroll: 2
      //     }
      //   }
      // ]
    });

    $(".section-slider--videos").on("beforeChange", function (){
      var youtubePlayer = $(this).find('iframe').get(0);
      if (youtubePlayer) {
          youtubePlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      }
    })  

    $('.slider--management').slick({
      // centerMode: true,
      lazyLoad: 'ondemand',
      dots: false,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 1,
      rows: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });

    $('.slider--gallery').slick({
      // centerMode: true,
      lazyLoad: 'ondemand',
      dots: false,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 1,
      rows: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ]
    });
  }

  let init = function () {

    setupEvents();
    setupForm();
    $("#formularz").parsley();
    $("#formularz-email").parsley();
    enableSmoothScroll();
    preload();
    setCountDown()

    $('.section-slider--facts a').on('click', function(e) {
      e.preventDefault()
    })
  };

  $(document).ready(function ($) {
    init();
  });
})();

